import useBootstrapData from '@/hooks/useBootstrapData'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import useSeti from '@/hooks/useSeti'
import pclnExperimentation from '@pcln/experimentation'
import hasRecentSearchFlightData from '../helper/hasRecentSearchFlightData'

export default function useGetMostRecentFlightSearch() {
  const {
    webstats: { clientGUID },
    appName,
    appVersion
  } = useBootstrapData()

  const fightsLPTripActivityBundlesExperiment = useSeti(
    'FLIGHT_LP_TRIPACTIVITY_BUNDLES',
    false
  )

  const hideFlightRecentSearchCard =
    fightsLPTripActivityBundlesExperiment === 'DEFAULT'

  const mostRecentFlightSearchData = useRecentSearchCard(
    clientGUID,
    { appName, appVersion },
    ['FLY']
  )

  if (!hasRecentSearchFlightData(mostRecentFlightSearchData)) {
    return []
  }

  pclnExperimentation.fireImpression('FLIGHT_LP_TRIPACTIVITY_BUNDLES')

  // Todo: During cleanup, please remove this logic when any of the VARIANTs or DEFAULT wins
  // Note: Here we return [] to hide Flight Recent Search Card when a recent flight search exists and SETI is DEFAULT
  if (hideFlightRecentSearchCard) {
    return []
  }

  return mostRecentFlightSearchData
}
